import SectionComponent from './section.component'

const SectionModule = angular.module('cdbl.section', [

])
  .component('cdblSection', SectionComponent)
  .name

export default SectionModule
